<template>
  <section
    class="external-essay-section"
    :style="{
      '--essay-panelBgColor': config.panelBgColor,
      '--essay-outlineColor': config.panelOutlineColor,
      '--essay-questionColor': config.questionColor,
      '--essay-questionBgColor': config.questionBgColor,
      '--essay-optionsColor': config.optionsColor,
      '--essay-optionsBgColor': config.optionsBgColor,
      '--essay-pickedColor': config.pickedColor,
      '--essay-pickedBgColor': config.pickedBgColor,
      '--essay-btnColor': config.btnColor,
      '--essay-btnBgColor': config.btnBgColor,
      '--essay-correctColor': config.correctColor,
      '--essay-correctBgColor': config.correctBgColor,
      '--essay-incorrectColor': config.incorrectColor,
      '--essay-incorrectBgColor': config.incorrectBgColor,
    }">
    <div class="question-container">
      <div class="essay-question">
        <div class="essay-question-img-container">
          <img class="essay-question-img" :src="currentQuestionComputed.question.image" v-if="currentQuestionComputed.question && currentQuestionComputed.question.image" />
        </div>
        <div class="question-text" v-if="currentQuestionComputed.question" v-html="currentQuestionComputed.question.prompt ? currentQuestionComputed.question.prompt : currentQuestionComputed.question"></div>
      </div>
      <div class="essay-options-and-nav">
        <transition name="fade-fast" mode="out-in">
          <div :key="essayKey" class="options-container" v-if="currentQuestionComputed.answers && currentQuestionComputed.answers.length">
            <label class="essay-item" v-for="(answer, index) in currentQuestionComputed.answers" :key="index">
              <textarea
                class="option-textarea"
                :value="interacted[currentQuestionIndex][index]"
                @change="handleTextChange($event, index)"
                v-if="interacted && interacted[currentQuestionIndex].length != 0 && interacted[currentQuestionIndex][index]" />
              <textarea class="option-textarea" :placeholder="answer.placeholder" v-model="answer.text" v-else />
            </label>
          </div>
        </transition>
        <div class="essay-interactions-nav-container" v-if="interacted === null || interacted[currentQuestionIndex]">
          <button class="interaction-send-btn btn-alt" @click="previousQuestion" :disabled="currentQuestionIndex == 0" v-if="questions.length > 1 && !isBusy"><i class="fas fa-chevron-left"></i></button>
          <button
            class="interaction-send-btn"
            style="margin: 0 auto"
            :disabled="isBusy"
            @click.prevent="setAnswer"
            v-if="!isBusy && !interacted && currentQuestionComputed.answers && currentQuestionComputed.answers[currentQuestionIndex] && currentQuestionComputed.answers[currentQuestionIndex].text">
            OK
          </button>
          <SpinnerButton
            class="btn-alt"
            style="min-width: 40px; padding: 10px; margin: 0 auto; z-index: 1"
            v-if="answers[currentQuestionIndex] && answers[currentQuestionIndex].length && answers[currentQuestionIndex][0] !== null && !finished && isBusy" />
          <button class="interaction-send-btn btn-alt" @click="nextQuestion" :disabled="questions.lenght == 1 || currentQuestionIndex == questions.length - 1" v-if="questions.length > 1 && !isBusy">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
        <transition appear name="categoryFade" mode="out-in">
          <div class="category-finish-panel" v-if="categoryEssayFinished">
            <img :src="categoryEssayFinishedImage" v-if="categoryEssayFinishedImage" />
            <div v-html="categoryEssayFinishedText"></div>
          </div>
        </transition>
      </div>
    </div>
    <transition appear name="delayed-opacity" mode="out-in" v-if="categoryOverride && categoryEssayFinished && categoryEssayFinishedText">
      <div class="category-finished-overlay-container">
        <div v-html="categoryEssayFinishedText"></div>
      </div>
    </transition>
    <transition appear name="delayed-opacity" mode="out-in" v-if="categoryOverride && categoryEssayFinished && categoryEssayFinishedImage">
      <div class="category-finished-overlay-container">
        <img :src="categoryEssayFinishedImage" @click="$router.push({ name: 'Home' })" />
      </div>
    </transition>
  </section>
</template>

<script>
import SpinnerButton from '@/components/ui/SpinnerButton.vue';

export default {
  name: 'ExternalEssay',

  components: { SpinnerButton },

  props: {
    config: {
      type: Object,
    },
    resultsTitle: {
      type: String,
    },
    typeShowResults: {
      type: Boolean,
    },
    interacted: {
      type: Array,
    },
    correct: {
      type: Array,
    },
    scored: {
      type: Number,
    },
    isCategory: {
      type: Boolean,
      default: false,
    },
    categories: {
      type: Array,
    },
    categoryOverride: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      essayKey: this.$RNG.randomKey(),
      isBusy: false,
      // showEssay: true,
      showQuestion: true,
      showResults: false,
      currentQuestion: {},
      currentQuestionIndex: 0,
      questions: [{ answers: [] }],
      answers: [],
      finished: false,
      score: null,
    };
  },

  computed: {
    currentQuestionComputed() {
      this.essayKey = this.$RNG.randomKey();
      return this.questions[this.currentQuestionIndex];
    },
    alradyInteracted() {
      return this.interacted && this.interacted.length === this.questions.length;
    },
    hasCorrect() {
      return this.correct && this.correct.length > 0;
    },
    categoryEssayFinished() {
      return this.typeShowResults && this.isCategory && (this.finished || (this.alradyInteracted && this.hasCorrect));
    },
    categoryEssayFinishedImage() {
      if (!this.categoryOverride && !this.isCategory) return '';
      else if (this.scored === null || this.scored === undefined) return '';
      else return this.categories[this.scored]?.image ?? '';
    },
    categoryEssayFinishedText() {
      if (!this.categoryOverride && !this.isCategory) return '';
      else if (this.scored === null || this.scored === undefined) return '';
      else return this.categories[this.scored]?.text ?? '';
    },
    isEnteringData() {
      return this.questions[0] && this.questions[0].answers[0] && this.questions[0].answers[0].text !== '';
    },
  },

  methods: {
    hideEssay() {
      this.$emit('hideEssay');
    },
    beginEssay(data) {
      // console.log('beginEssay', data);
      if (this.isEnteringData) return;
      this.questions = data.questions;
      this.questions.map((q) => {
        q.answers.map((a) => {
          a.placeholder = a.text;
          a.text = '';
        });
      });
      this.finished = false;
      let marker = `${this.$store.state.user.id}-${data.id}`;

      if (this.$store.state.markers.answeredEssay.includes(marker)) {
        // this.finished = true;
      }
      this.showResults = this.typeShowResults;
    },
    handleTextChange(e, index) {
      if (this.questions[this.currentQuestionIndex].answers[index] && this.questions[this.currentQuestionIndex].answers[index].text) {
        this.questions[this.currentQuestionIndex].answers[index].text = e.target.value;
        this.setAnswer();
      }
    },
    setAnswer() {
      this.isBusy = true;
      this.questions.map((question) => {
        this.answers = [question.answers.map((answer) => answer.text)];
      });
      const obj = {
        id: this.questions[0].id,
        answers: this.answers.map((a) => JSON.stringify(a)),
      };
      this.$emit('finished', obj);

      setTimeout(() => {
        this.isBusy = false;
        if (this.currentQuestionIndex == this.questions.length - 1) this.finished = true;
        else this.nextQuestion();
      }, 1500);
    },
    previousQuestion() {
      if (this.currentQuestionIndex == 0) return;
      this.currentQuestionIndex--;
      this.questions[this.currentQuestionIndex] = this.questions[this.currentQuestionIndex];
    },
    nextQuestion() {
      if (this.currentQuestionIndex == this.questions.length - 1) return;
      this.currentQuestionIndex++;
      this.questions[this.currentQuestionIndex] = this.questions[this.currentQuestionIndex];
    },
    setScore(score) {
      this.score = score;

      setTimeout(() => {
        this.showResults = this.typeShowResults;
      }, 300);
    },
    toggleAnswer(e, answerIndex, id) {
      // console.log('toggleAnswer', { e }, e.currentTarget.checked, answerIndex);
      if (this.finished) return;
      if (e.currentTarget.checked) {
        // console.log('add answer', answerIndex);
        if (!this.answers[this.currentQuestionIndex]) this.answers[this.currentQuestionIndex] = [];
        this.answers[this.currentQuestionIndex] = [...this.answers[this.currentQuestionIndex], answerIndex];
        if (this.answers[this.currentQuestionIndex].length > 1) this.answers[this.currentQuestionIndex] = this.answers[this.currentQuestionIndex].filter((a) => a || a == 0);
      } else {
        // console.log('remove answer', answerIndex);
        this.answers = this.answers.map((answer, i) => {
          if (i == this.currentQuestionIndex) answer = answer.filter((a) => a != answerIndex);
          return answer;
        });
      }
      this.questions[this.currentQuestionIndex].answers = this.questions[this.currentQuestionIndex].answers.map((answer, i) => {
        return answer;
      });
      // this.essayKey = this.$RNG.randomKey();

      const isSingleOption = this.currentQuestionComputed.question?.isSingleOption;
      if (isSingleOption) {
        this.answers[this.currentQuestionIndex] = [answerIndex];
      }
    },
  },

  beforeMount() {
    this.showResults = this.typeShowResults;
  },
};
</script>

<style scoped lang="scss">
.external-essay-section {
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;

  .essay-title {
    position: relative;
    margin: 0px auto 30px;
    padding: 5px 30px;
    width: auto;
    text-transform: uppercase;
    background: var(--live-bgColor);
    color: var(--live-textColor);
    box-shadow: 0 0 20px #000;
    border-radius: var(--input-borderRadius) var(--input-borderRadius) 0 0;
  }

  .question-container {
    position: relative;
    width: 100%;
    max-width: 1024px;
    border-radius: var(--input-borderRadius);
    border: 1px solid var(--essay-outlineColor);
    background: var(--essay-panelBgColor);
    overflow: hidden;
    @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
      background: var(--essay-panelBgColor);
    }

    .essay-options-and-nav {
      position: relative;
    }
  }

  .category-finish-panel {
    position: sticky;
    inset: 0;
    background: var(--essay-panelBgColor);
    z-index: 1;
    min-height: 100%;
    flex-grow: 1;

    // display: flex;
    // justify-content: center;
    // align-items: center;

    aspect-ratio: 16/9;
    img {
      position: absolute;
      inset: 0 0 auto 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
    }

    div {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .question-text {
    position: relative;
    margin: 0 15px 15px;
    padding: 8px;
    border-radius: var(--input-borderRadius);
    color: var(--essay-questionColor);
    background: var(--essay-questionBgColor);

    filter: brightness(1);

    font-size: 1.2rem;
  }

  .options-container {
    position: relative;
    width: 100%;
    margin: 0;
    padding: 0 16px;

    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-direction: column;
    flex-wrap: wrap;
  }

  .essay-item {
    cursor: pointer;
    position: relative;
    min-height: 40px;
    min-width: 40%;
    flex-grow: 1;
    margin: 6px 0;

    color: var(--essay-optionsColor);
    border-radius: var(--input-borderRadius);

    display: flex;
    gap: 6px;
    justify-content: space-between;
    align-items: center;

    caret-color: var(--essay-pickedBgColor);
    .option-textarea {
      position: relative;
      padding: 10px;
      width: 100%;
      color: inherit;
      background: var(--essay-optionsBgColor);
      border: none;
      z-index: 1;

      display: flex;
      align-items: center;
      &:focus-within {
        // transform: scale(0.98);
        // opacity: 0.8;
        outline: 1px solid var(--essay-pickedBgColor);
      }
      &:disabled {
        opacity: 0.7;
        cursor: auto;
      }
      &::placeholder {
        color: var(--essay-optionsColor);
        opacity: 0.7;
      }
    }
    .option-item-status {
      position: absolute;
      right: 0;
      min-width: 40px;
      min-height: 100%;
      // background: var(--essay-optionsBgColor);

      display: flex;
      align-items: center;
      justify-content: center;

      &.correct {
        color: var(--essay-correctColor);
        background: var(--essay-correctBgColor);
        border-radius: 0 var(--input-borderRadius) var(--input-borderRadius) 0;
      }
      &.incorrect {
        // background: rgb(182, 0, 85);
        color: var(--essay-incorrectColor);
        background: var(--essay-incorrectBgColor);
        border-radius: 0 var(--input-borderRadius) var(--input-borderRadius) 0;
      }
      input {
        display: none;
      }
    }
  }

  .essay-interactions-nav-container {
    width: 100%;
    padding: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .interaction-send-btn {
      cursor: pointer;
      position: relative;
      padding: 10px 18px;
      border: none;
      outline: none;
      color: var(--essay-btnColor);
      background: var(--essay-btnBgColor);
      border-radius: var(--input-borderRadius);

      &:disabled {
        opacity: 0.1;
      }
    }
  }

  .essay-question-img-container {
    padding: 12px 0;
    .essay-question-img {
      width: 100%;
      height: auto;
      max-width: 100%;
      max-height: 306px;
      object-fit: contain;
      border-radius: var(--input-borderRadius) var(--input-borderRadius) 0 0;
    }
  }
}
</style>
